import Debouncer, { REQUEST_DELAY_MS } from 'middlewares/Debouncer';
import { UserInfo } from 'api/LoanOriginationSystem/LoanOriginationSystemApplicationsApi';
import { ESignTemplatesActionOrigin, getESignTemplates } from 'ESignTemplates/ActionCreator';
import { DOCU_SIGN_TEMPLATES_PER_PAGE_DEFAULT } from 'components/DocuSign/pagination';
import { DocuSignFiltersActionType } from './ActionTypes';

export default Debouncer<{ integrationId: string; members: UserInfo[] }>(
  (payload, getState) => {
    const { docuSign } = getState();
    const { sortingType, filters } = docuSign;

    return getESignTemplates(
      {
        status: filters.selectedStatus,
        search: filters.searchInputValue,
        integrationId: payload.integrationId,
        members: payload.members,
        createdDateRange: filters.createdDateRange,
        updatedDateRange: filters.updatedDateRange,
      },
      sortingType,
      DOCU_SIGN_TEMPLATES_PER_PAGE_DEFAULT,
    );
  },
  [DocuSignFiltersActionType.FilterTemplatesByMembers],
  REQUEST_DELAY_MS,
  ESignTemplatesActionOrigin.DocuSignConfiguration,
);
